module.exports = __webpack_public_path__ + "img/icon-device-monitoring.2c26a114.svg";